function resolveURL(url, base = "", currentPath = typeof window !== "undefined" ? window.location.pathname : "") {
  url = url.replace("{{path}}", currentPath);
  return base && url.startsWith("/") ? base + url : url;
}
export {
  resolveURL
};
